module.exports = __webpack_public_path__ + "img/introduc_banner01.0642ce84.jpg";